/**
 * LocationFilter Component
 * 
 * "Where are you?" filter section with pill button options.
 * Options: AT HOME, OUTDOOR, BED, ON THE MOVE, AT THE TABLE
 */

import { useFilter, LocationOption } from '../../../contexts/FilterContext';
import FilterSection from './FilterSection';
import FilterPillButton from './FilterPillButton';

// Available location options
const LOCATION_OPTIONS: LocationOption[] = [
  'AT HOME',
  'OUTDOOR',
  'BEDTIME',
  'ON THE MOVE',
  'AT THE TABLE',
];

export default function LocationFilter() {
  const { filters, setLocation } = useFilter();

  const handleSelect = (location: LocationOption) => {
    // Toggle: if already selected, deselect; otherwise select
    if (filters.location === location) {
      setLocation(null);
    } else {
      setLocation(location);
    }
  };

  return (
    <FilterSection title="Where are you?">
      <div className="flex flex-wrap gap-2">
        {LOCATION_OPTIONS.map((option) => (
          <FilterPillButton
            key={option}
            label={option}
            isSelected={filters.location === option}
            onClick={() => handleSelect(option)}
          />
        ))}
      </div>
    </FilterSection>
  );
}
